module.exports = __webpack_public_path__ + "static/media/jung.385e778a.jpg";